import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, Span, ProgressBox, ProgressStat } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const DysfunctionalBeliefsFirstContPage = ({ background, number, user }) => {
  const destinyRole = parseFloat(user['Rol de la casualidad']);

  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>3.2. Creencias Disfuncionales</h2>
          <p className='justified'>
            El tener ideas o creencias equivocadas sobre las implicancias del
            proceso de elección de carrera es una de las{' '}
            <strong>
              dificultades más importantes y más comunes que enfrentan las
              personas al momento de tomar este tipo de decisiones
            </strong>
            .
          </p>
          <p className='justified'>
            Es importante identificar estas creencias erróneas y cuestionarlas,
            ya que pueden estar obstaculizando el proceso de toma de decisión.
          </p>
          <p className='justified'>
            Resultados en
            <Span strong color={polarColors[0]}>
              {' '}
              ROJO{' '}
            </Span>
            sugieren la alta presencia de creencias disfuncionales en estas
            áreas. Resultados en{' '}
            <Span strong color={polarColors[4]}>
              VERDE
            </Span>{' '}
            sugieren la baja presencia o ausencia de creencias disfuncionales.
          </p>
          <p className='justified'>
            Piensa en estos colores similar a como si fuera un semáforo.{' '}
            <strong>
              El color rojo indica que debes detenerte a revisar tus creencias y
              cuestionarlas
            </strong>
            , ya que pueden estar obstaculizando tu proceso. Esto es parte
            normal del proceso de toma de decisiones. El color verde indica que
            tus creencias son funcionales y están alineadas con el proceso
            vocacional y no son obstáculo para tu proceso de toma de decisión.
          </p>
          <br />
          <h3>3.2.1. El rol de la casualidad y el destino</h3>
          <p className='justified'>
            Sostener la creencia de que elementos como{' '}
            <strong>
              el destino, el tiempo o el azar son los principales determinantes
              de nuestro futuro
            </strong>{' '}
            puede llevarnos a minimizar la importancia de la toma de decisiones
            activa y deliberada en relación con nuestra carrera. Estas creencias
            pueden derivar en invertir muy pocos esfuerzos al momento de decidir
            sobre nuestras opciones vocacionales.
          </p>
          <p className='justified'>
            Sin un análisis exhaustivo de las posibilidades, podríamos
            arriesgarnos a adoptar decisiones subóptimas que no reflejan
            plenamente nuestras habilidades, intereses y objetivos personales.
          </p>
          {/* <p className='justified'>
            Ejemplo, un estudiante puede creer que "si está destinado a ser
            psicólogo”, por lo tanto, “ocurrirá de alguna manera", y puede pasar
            por alto la necesidad de analizar sus habilidades, intereses, y la
            inversión de tiempo y estudio necesarios para esa carrera.
          </p> */}
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>- Trabajar en un plan de carrera.</li>
            <li>- Desarrollar criterios de elección.</li>
            <li>- Trabajar sobre un enfoque reflexivo de toma de decisiones.</li>
          </ul>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={destinyRole}
                  backColor={() => getColor(destinyRole)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{destinyRole}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default DysfunctionalBeliefsFirstContPage;
